var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7 6.7L12.7 16.7C12.5 16.9 12.3 17 12 17H8C7.4 17 7 16.6 7 16V12C7 11.7 7.1 11.5 7.3 11.3L17.3 1.3C17.7 0.9 18.3 0.9 18.7 1.3L22.7 5.3C23.1 5.7 23.1 6.3 22.7 6.7ZM21 14.7V20C21 21.7 19.7 23 18 23H4C2.3 23 1 21.7 1 20V6C1 4.3 2.3 3 4 3H9.3C9.9 3 10.3 3.4 10.3 4C10.3 4.6 9.9 5 9.3 5H4C3.4 5 3 5.4 3 6V20C3 20.6 3.4 21 4 21H18C18.6 21 19 20.6 19 20V14.7C19 14.1 19.4 13.7 20 13.7C20.6 13.7 21 14.1 21 14.7ZM18 3.4L20.6 6L11.6 15H9V12.4L18 3.4Z",
    fill: "#4B4B4B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3622_35459",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7 6.7L12.7 16.7C12.5 16.9 12.3 17 12 17H8C7.4 17 7 16.6 7 16V12C7 11.7 7.1 11.5 7.3 11.3L17.3 1.3C17.7 0.9 18.3 0.9 18.7 1.3L22.7 5.3C23.1 5.7 23.1 6.3 22.7 6.7ZM21 14.7V20C21 21.7 19.7 23 18 23H4C2.3 23 1 21.7 1 20V6C1 4.3 2.3 3 4 3H9.3C9.9 3 10.3 3.4 10.3 4C10.3 4.6 9.9 5 9.3 5H4C3.4 5 3 5.4 3 6V20C3 20.6 3.4 21 4 21H18C18.6 21 19 20.6 19 20V14.7C19 14.1 19.4 13.7 20 13.7C20.6 13.7 21 14.1 21 14.7ZM18 3.4L20.6 6L11.6 15H9V12.4L18 3.4Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3622_35459)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#4B4B4B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.274498679892ec6f522551a4419c09b0.svg";
export { ForwardRef as ReactComponent };